import prettyBytes from 'pretty-bytes';

export default function (size, locale = 'en') {
    if (!Number.isFinite(size)) {
        return '';
    }

    return prettyBytes(size, { locale });
}
